<div class="alert alert-success" *ngIf="alertSuccess">
  Uploaded successfully!
</div>
<div class="alert alert-danger" *ngIf="alertFailure">
  {{errorMsg}} !
</div>
<div class="alert alert-success" *ngIf="deleteSuccess">
  Deleted successfully!
</div>
<div class="alert alert-danger" *ngIf="timeOutError">
  {{timeoutErrorMessage}}
</div>
<div class="alert alert-danger" *ngIf="errorMsgUploadSave">
  Uploading failed and data will not be saved!
</div>

<div class="common-padding">

  <!-- <h4 class="headspace">CONFIGURE GALLERY</h4> -->
  <div class="col-md-12 col-xs-12 col-sm-12 heading p-0 mt-4 mb-4">
    <span class="span-create-edit-hoshin color">CONFIGURE GALLERY</span>
    <span class="pt-2" style="font-size: 13px;"><a href="assets/userguides/ConfigureGalleryUserGuide.pdf" download class="pl-3 download-link">User Guide</a></span>
  </div>
  <form class="admin-font-style" (ngSubmit)="onChapterGallerySubmit()" action="" name="chapterGalleryForm"
    #chapterGalleryForm="ngForm" enctype="multipart/form-data">
    <div>
      <div class="col-md-6 inlineFlex leftFloat zeroLeftPad">
        <label for="selectSite" class="col-md-3 zeroLeftPad">Select Site<span class="star"> *</span></label>
        <ng-select id="selectSite" placeholder="--Select Site--" class="col-md-8" [items]="siteList" name="siteName"
          bindLabel="siteName" [(ngModel)]="selectedSite" (change)="siteChange($event)" required></ng-select>
      </div>
      <div class="col-md-6 inlineFlex zeroRightPad">
        <span class="divide-width"></span>
        <label for="selectedBpg" class="col-md-3">Select ERG <span class="star"> *</span></label>
        <ng-select id="selectBpg" placeholder="--Select ERG--" class="col-md-8 zeroRightPad" [items]="bpgList" name="bpgName"
          bindLabel="bpgName" [(ngModel)]="selectedBpg" (change)="bpgChange($event)" required></ng-select>
      </div>

      <div class="col-md-6 inlineFlex leftFloat zeroLeftPad eventPadding">
        <input class="radio-input-align radio-margin" type="radio" name="isEventExpense" [value]="true"
          [(ngModel)]="eventPicture" />
        <span class="col-md-5 pt-2">Event</span>
        <input class="radio-input-align radio-input-margin radio-margin" type="radio" name="isEventExpense"
          [value]="false" [(ngModel)]="eventPicture" /> <span class="col-md-5 pt-2">Non-Event</span>
      </div>



      <div id="config_gallery" class="col-md-6 inlineFlex zeroRightPad" *ngIf="eventPicture">
        <span class="divide-width"></span>
        <label for="selectEvent" class="col-md-3">Select Event <span class="star"> *</span></label>
        <ng-select id="selectEvent" placeholder="--Select Event--" class="col-md-8 zeroRightPad" [items]="eventList" name="evenName"
          bindLabel="eventName" bindValue="eventId" [(ngModel)]="eventId" [required]="eventPicture == true"></ng-select>
      </div>

      <div class="col-md-6 inlineFlex zeroRightPad">
        <label class="col-md-3 zeroLeftPad" [ngClass]="{'addMargin': eventPicture == false}" for="docName">Title<span
            class="star">*</span></label>
        <input type="text" [maxlength]="50" class="form-control col-md-8 zeroRightPad placeholder" name="docName" id="docName"
          placeholder="Title" [(ngModel)]="documentName" required>
      </div>

      <div class="col-md-6 inlineFlex  zeroLeftPad">
        <label class="col-md-3 zeroLeftPad upload-label-padding" for="UploadDocument">Upload<span class="star">
            *</span></label>

        <input #myInput type="file" id="UploadDocument" (change)="onFileSelected($event)" name="UploadDocument"
          placeholder="Upload" class="form-control input-lg upload-icon hideInput" [multiple]="true">
        <label class="form-control input-lg upload-icon col-md-8 width-label" for="UploadDocument"><label
            class="docNameEllipsis resource-ellipsis col-md-8 upload-file-name-class ">{{selectedFileName}}</label>
          <p class="formats-font">( jpeg, png, jpg, mp4, mov, ogg )</p>
          <p class="errorMessage" *ngIf="fileSizeExtensionError">You can only upload the
            file of size less than 500 MB </p>
          <p class="errorMessage" *ngIf="fileExtensionError">Invalid format</p>
        </label>

      </div>

    </div>
    <div class="top-space text-center col-md-12">

      <button type="submit" id="submitButton" class="btn btn-danger col-sm-2 col-md-2 style btn-width"
        [disabled]="(!chapterGalleryForm.valid || isFileUploded == false )  || fileSizeExtensionError"
        data-target="#myModal" data-toggle="modal">SAVE</button>
      <span class="preview"></span>
      <button type="button" class="btn btn-danger col-sm-2 col-md-2 style btn-width" data-toggle="modal"
        (click)="resetClick()" data-target="#myModal">RESET</button>
    </div>

  </form>
  <app-confirmation-modal [PData]="msg1" (emitPass)="this[method](param)" id="2"></app-confirmation-modal>

  <div class="col-md-12  search-div-style">

    <div class="col-md-3 div-bottom">
      <ng-select placeholder="--Select Site--" [items]="siteListSearch" name="siteName" bindLabel="siteName"
        [(ngModel)]="selectedSiteSearch" (change)="siteChangeSearch($event)" required></ng-select>
    </div>
    <div class="col-md-3  div-bottom">
      <ng-select placeholder="--Select ERG--" [items]="bpgListSearch" name="bpgName" bindLabel="bpgName"
        [(ngModel)]="selectedBpgSearch" (change)="bpgChangeSearch($event)"></ng-select>
    </div>

    <div class="col-md-3  div-bottom">
      <ng-select placeholder="--Select Type--" [items]="typeList" name="type" bindLabel="type" bindValue="type"
        [(ngModel)]="filterType"></ng-select>
    </div>


    <div class="col-md-2 div-bottom">

      <button type="button" class="btn btn-danger search-button-style gallery-but"
        (click)="getChapterGalleryListSearch()">Search</button>
    </div>
  </div>
  <p class="noDataFound text-center" *ngIf="noDataFound"> No data found </p>
  <div id="tabledemo1" class="table-contents">
    <div class="table-container">
      <div>
        <div class="box"
          *ngFor="let data of galleryItemsList | paginate: { itemsPerPage: limit, currentPage: currentPage,totalItems: numberOfElements };let i=index ">

          <div class="text1"><a downloadAttachments-btn id='downloadFiles{{i}}'
              (click)="downloadDocument(data.fileName,i)">
              <img
                *ngIf="(data.fileName.toLowerCase().indexOf('.pdf') !== -1) || (data.fileName.toLowerCase().indexOf('.txt') !== -1) || (data.fileName.toLowerCase().indexOf('.xls') !== -1) || (data.fileName.toLowerCase().indexOf('.xlsx') !== -1) || (data.fileName.toLowerCase().indexOf('.doc') !== -1) || (data.fileName.toLowerCase().indexOf('.docx') !== -1) || (data.fileName.toLowerCase().indexOf('.ppt') !== -1) || (data.fileName.toLowerCase().indexOf('.pptx') !== -1)"
                src="assets/images/download-button.png" alt="Angular Logo" class="image delete-icon download-icon" title="Download"></a>
          </div>
          <div class="text1 width-delete"><img src="assets/images/delete.png" alt="Angular Logo" class="image delete-icon" title="Delete"
              data-toggle="modal" data-target="#myModal" (click)="deleteGalleryConfirmation(data.galleryId)"></div>
          <img class="image-box-style"
            *ngIf="(data.fileName.toLowerCase().indexOf('.jpg') !== -1) ||(data.fileName.toLowerCase().indexOf('.png') !== -1) || (data.fileName.toLowerCase().indexOf('.jpeg') !== -1)"
            src="{{data.fileName}}" alt="Angular Logo">
          <img class="image-box-style"
            *ngIf="(data.fileName.toLowerCase().indexOf('.mov') !== -1) || (data.fileName.toLowerCase().indexOf('.mp4') !== -1) || (data.fileName.toLowerCase().indexOf('.ogg') !== -1)"
            src="assets/images/video.jpg" alt="Angular Logo">
          <img class="image-box-style"
            *ngIf="(data.fileName.toLowerCase().indexOf('.pdf') !== -1)"
            src="assets/images/pdf.png" alt="Angular Logo">
          <img class="image-box-style"
            *ngIf="(data.fileName.toLowerCase().indexOf('.txt') !== -1)"
            src="assets/images/txt.png" alt="Angular Logo">
          <img class="image-box-style"
            *ngIf="(data.fileName.toLowerCase().indexOf('.doc') !== -1) || (data.fileName.toLowerCase().indexOf('.docx') !== -1)"
            src="assets/images/doc.png" alt="Angular Logo">
          <img class="image-box-style"
            *ngIf="(data.fileName.toLowerCase().indexOf('.xls') !== -1) || (data.fileName.toLowerCase().indexOf('.xlsx') !== -1)"
            src="assets/images/xls.png" alt="Angular Logo">
          <img class="image-box-style"
            *ngIf="(data.fileName.toLowerCase().indexOf('.ppt') !== -1) || (data.fileName.toLowerCase().indexOf('.pptx') !== -1)"
            src="assets/images/ppt.png" alt="Angular Logo">

          <div class="text">
            <h6 class="font-size">Site : {{data.siteName}}</h6>
            <h6 class="font-size">ERG : {{data.bpgName}}</h6>
            <h6 class="font-size">Title : {{data.documentName}}</h6>

          </div>

        </div>
      </div>
    </div>

    <div id="bpgpagination" *ngIf="numberOfElements > limit" class="pagination-outerdiv">
      <span>Showing {{currentShowingElements}} of {{numberOfElements}} results</span>
      <pagination-controls previousLabel="Prev" nextLabel="Next" (pageChange)="pageChanged($event)">
      </pagination-controls>
    </div>
  </div>
</div>
